// extracted by mini-css-extract-plugin
export default {"animate-on-value-change":"animate-on-value-change--oN6-7","animateOnValueChange":"animate-on-value-change--oN6-7","animate":"animate--1oeJ_"};